// Heartbeat scheduler with jitter support.
export function createHeartbeat({
  intervalMs,
  jitterMs = 3_000,
  send,
  enabled = true,
}) {
  let timer;

  const schedule = () => {
    if (!enabled) return;
    clearTimeout(timer);
    const jitter = (Math.random() * 2 - 1) * jitterMs;
    timer = setTimeout(tick, Math.max(1_000, intervalMs + jitter));
  };

  const tick = () => {
    if (!enabled) return;
    try {
      send?.();
    } finally {
      schedule();
    }
  };

  return {
    start() {
      if (!enabled) return;
      schedule();
    },
    stop() {
      clearTimeout(timer);
    },
    isRunning() {
      return !!timer;
    },
  };
}

export default createHeartbeat;
